import { render, staticRenderFns } from "./Questoes.vue?vue&type=template&id=5b83a802&scoped=true&"
import script from "./Questoes.vue?vue&type=script&lang=js&"
export * from "./Questoes.vue?vue&type=script&lang=js&"
import style0 from "./Questoes.vue?vue&type=style&index=0&id=5b83a802&prod&lang=scss&scoped=true&"
import style1 from "./Questoes.vue?vue&type=style&index=1&id=5b83a802&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83a802",
  null
  
)

export default component.exports